import { consents } from './Consents/Consents'
import { executions } from './Executions/Executions'
import { task } from './Task/Task'

export const BenderApi = {
  executions,
  task,
  consents
}
